import React from 'react';
import qs from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { setVisitOnBoarding } from 'redux/slice/stores';
import CONST_ENV from 'services/env';
import { booleanParser } from 'services/booleanParser';
import { isWhiteLabelProject } from 'utils/isWhiteLabelProject';

const PROJECT_NAMES = {
	ENTEKHAB: 'entekhab',
	KEEPA: 'keepa',
	HAMTALAND: 'hamtaland',
	RAYANSAIPA: 'rayansaipa',
	DEMO: 'demo',
	TISA: 'tisa',
	SAANA: 'saana',
	ARBAEEN: 'arbaeen',
};

const useWhiteLabelProject = () => {
	const dispatch = useDispatch();
	const isWhiteLabelDomain = isWhiteLabelProject();
	const project = process.env.REACT_APP_PROJECT_NAME;
	const isDev = booleanParser(process.env.REACT_APP_TEST_SERVER);
	const token = useSelector((state) => state.login.token);

	const checkProject = (projectName) => project === projectName;

	const projectStatus = {
		isWhiteLabelDomain,
		isEntekhab: checkProject(PROJECT_NAMES.ENTEKHAB),
		isKeepa: checkProject(PROJECT_NAMES.KEEPA),
		isHamtaland: checkProject(PROJECT_NAMES.HAMTALAND),
		isRayansaipa: checkProject(PROJECT_NAMES.RAYANSAIPA),
		isDemo: checkProject(PROJECT_NAMES.DEMO),
		isTisa: checkProject(PROJECT_NAMES.TISA),
		isSaana: checkProject(PROJECT_NAMES.SAANA),
		isArbaeen: checkProject(PROJECT_NAMES.ARBAEEN),
	};

	React.useEffect(() => {
		const parsedToken = qs.parse(`?token=${token}`);
		if (isWhiteLabelDomain && (!parsedToken?.token || parsedToken?.token === 'null')) {
			dispatch(setVisitOnBoarding(false));
		}
	}, [dispatch, isWhiteLabelDomain, token]);

	return projectStatus;
};

export default useWhiteLabelProject;
